export const roundToTwoDecimals = (num?: number) => num ? Math.round(num * 100) / 100 : 0;
export const twoNumbersMean = (num1?: number, num2?: number) => ((num1 && num2) ? (num1 + num2) / 2 : (num1 || num2));